export const OFFER_FINANCIAL_PRODUCT_LIST_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.OfferFinancialProductListComputed";
export const OFFER_FINANCIAL_PRODUCT_LIST_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.OfferFinancialProductListInvalidated";

export const OFFER_FINANCIAL_PRODUCT_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.OfferFinancialProductInvalidated";
export const OFFER_FINANCIAL_PRODUCT_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Products.OfferFinancialProductUpdated";
